import { API_BASE_URL } from "@/lib/config";

export async function fetchControlPlaneVersion(): Promise<string | null> {
	const response = await fetch(`${API_BASE_URL}/health/live`, {
		method: "GET",
		credentials: "omit",
		headers: { Accept: "application/json" },
	});
	if (!response.ok) {
		return null;
	}
	const body: unknown = await response.json();
	if (typeof body !== "object" || body === null || !("version" in body)) {
		return null;
	}
	const version = body.version;
	if (typeof version !== "string") {
		return null;
	}
	const trimmed = version.trim();
	return trimmed.length > 0 ? trimmed : null;
}
